import * as React from "react";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import {
    SEARCH_VIEW_LIVE_PERFORMANCE_SUBMISSION,
} from "../Consts";
import { useMsal } from "@azure/msal-react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { setDataSource } from "../../redux/reducers/MembersPortalReducer";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { DataSource } from "../../repertoire/types/DataSource";
import { MemberPortalSearchType } from "../../redux/types/MemberPortalSearchType";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import LivePerformanceSubmissionSearchView from "./components/LivePerformanceSubmissionSearchView";
import { SearchRequests } from "../services/SearchRequests";
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP } from "../ConfigurationConsts";
import { FormatFields } from "../../redux/types/FormatFields";
import { IUsageGroupResult } from "../../repertoire/types/usageTypes/IUsageGroupsSearchResult";
import { ILivePerformanceSearchQuery } from "../types/ILivePerformanceSearchQuery";
import { ILivePerformanceResult } from "../types/ILivePerformancesSearchResult";
import ITooltip from "../../repertoire/components/Tooltip/IToolTip";
import { PERMISSION_MESSAGE } from "../../repertoire/Consts";
import { MembersPortalRoles } from "../../redux/types/MembersPortalRoles";
import { MembersPortalService } from "../../redux/services/MembersPortalService";
import { ICustomerVenue } from "../../repertoire/types/ISetListVenue";
import InfoToggle from "../sharedComponents/button/InfoToggle";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";

export interface ILivePerformanceSubmissionPageProps {
    livePerformanceSubmissionPageData?: IMembersPortalComponentDataItem;
    livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchSuccessful: boolean;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    currentUserNameNumber?: string;
    memberPortalSearchType: MemberPortalSearchTypeItem;
    addNewLivePerformance: (lookups: ILookupDictionary, isNew?: boolean, draftSetListsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[], distributionCode?: string, currentUserNameNumber?: string) => void;
    searchLivePerformances: (query: ILivePerformanceSearchQuery) => void;
    livePerformanceSearchResults?: ILivePerformanceResult[];
    getLivePerformanceDetails: (usageId) => void;
}

const LivePerformanceSubmissionPage = (props: ILivePerformanceSubmissionPageProps) => {
    const [loaded, setLoaded] = React.useState(false);
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        checkIfLoaded();

        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
    }, [])

    React.useEffect(() => {
        checkIfLoaded();
    }, [props, loaded])


    const checkIfLoaded = () => {
        const { livePerformanceSubmissionPageData } = props;

        if (livePerformanceSubmissionPageData.fields && livePerformanceSubmissionPageData.fields.length >= 1 && !loaded) {
            setLoaded(true);
            const header = livePerformanceSubmissionPageData.fields.find(f => f.name === "PageTitle");
            if (header) {
                document.title = header.data;
            }
        }
    }

    const updateUserPagination = (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => {
        const { defaultActiveAccordions, allResultsPerPage, updateUserPreferences, updatePagination } = props;
        updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
        updateUserPreferences(allResultsPerPage, defaultActiveAccordions, undefined, undefined, undefined, indexOfFirstResult, indexOfLastResult, resultsPerPage, repertoireSection);
    }

    const searchLivePerformances = () => {

    }

    let currentDataSource = "";
    switch (props.memberPortalSearchType.code) {
        case MemberPortalSearchType.MyDraftSearch.code:
            setDataSource(DataSource.Intray);
            currentDataSource = DataSource.Intray;
            break;
        case MemberPortalSearchType.MyRegisteredSearch.code:
            setDataSource(DataSource.Repertoire);
            currentDataSource = DataSource.Repertoire;
            break;
    }
    const addNewLivePerformance = (): void => {
        const { addNewLivePerformance, lookupValues, livePerformanceMaintenanceGeneralDataViewData, currentUserNameNumber } = props;
        const formatFields = SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
            .then(formats => {
                const distribution = SearchRequests.getLivePerformancesDistribution()
                    .then(distribution => {
                        addNewLivePerformance(lookupValues, true, livePerformanceMaintenanceGeneralDataViewData, formats, distribution ? distribution.distributionCode : "", currentUserNameNumber);
                    });
            });
    }

    if (loaded) {
        const {
            livePerformanceSubmissionPageData,
            searchViewData,
            searchResultsTableData,
            searchSuccessful,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            loadMembersPortalFromPath,
            currentPage,
            resetPagination,
            sortSearchResults,
            lookupValues,
            searchLivePerformances,
            livePerformanceSearchResults,
            getLivePerformanceDetails,
            currentUserNameNumber,
            tabs,
            activeTab
        } = props;


        let searchPageLabelTitle = null;
        if (livePerformanceSubmissionPageData && livePerformanceSubmissionPageData.fields.length > 0) {
            searchPageLabelTitle = livePerformanceSubmissionPageData.fields.find((v, i, a) => v.name == "searchPageLabelTitle").data;
        }

        const hasPermission = MembersPortalService.hasPermissionForMenu("livePerformanceSubmission", MembersPortalRoles.FullAccess);

        const infoToggleHeaderField = livePerformanceSubmissionPageData.fields
            .find(x => x.name === 'infoToggleHeader');

        const infoToggleHtmlField = livePerformanceSubmissionPageData.fields
            .find(x => x.name === 'infoToggleHTML');


        const renderInfoToggle = (
            <InfoToggle
                headerTextItem={infoToggleHeaderField}
                htmlTextItem={infoToggleHtmlField}
                currentUserNameNumber={currentUserNameNumber}
                lookupValues={lookupValues}
                loadMembersPortalFromPath={loadMembersPortalFromPath}
            />
        )

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <span className="title">{searchPageLabelTitle}</span>
                        {hasPermission ? (
                            <div className="newWorkButton" title="Register New Work">
                                <div className="IconTextButton" onClick={addNewLivePerformance}>
                                    <i
                                        className="icon ms-Icon ms-Icon--CircleAddition"
                                        aria-hidden="true"
                                    ></i>
                                    {
                                        livePerformanceSubmissionPageData.fields.find(
                                            f => f.name === "newLivePerformance"
                                        ).data
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className="newWorkButton" title="Register New Work">
                                <ITooltip
                                    tooltipContent={PERMISSION_MESSAGE}
                                    showTooltip={true}
                                    placement="top"
                                >
                                    <span style={{ display: 'inline-block' }}>
                                        <div className="IconTextButton disabled">
                                            <i
                                                className="icon ms-Icon ms-Icon--CircleAddition disabled"
                                                aria-hidden="true"
                                            ></i>
                                            {
                                                livePerformanceSubmissionPageData.fields.find(
                                                    f => f.name === "newLivePerformance"
                                                ).data
                                            }
                                        </div>
                                    </span>
                                </ITooltip>
                            </div>
                        )}
                    </div>
                </div>
                {renderInfoToggle }
                <LivePerformanceSubmissionSearchView
                    searchViewData={searchViewData}
                    searchResultsTableData={searchResultsTableData}
                    componentInstance={SEARCH_VIEW_LIVE_PERFORMANCE_SUBMISSION}
                    modalProps={undefined}
                    dataSource={currentDataSource}
                    hideModal={undefined}
                    lookupValues={lookupValues}
                    searchSuccessful={searchSuccessful}
                    indexOfFirstResult={indexOfFirstResult}
                    indexOfLastResult={indexOfLastResult}
                    resultsPerPage={resultsPerPage}
                    currentPage={currentPage}
                    resetPagination={resetPagination}
                    updatePagination={updateUserPagination}
                    sortSearchResults={sortSearchResults}
                    searchDisabled={false}
                    searchLivePerformances={searchLivePerformances}
                    livePerformanceSearchResults={livePerformanceSearchResults}
                    getLivePerformanceDetails={getLivePerformanceDetails}
                    currentUserNameNumber={currentUserNameNumber}
                    tabs={tabs}
                    activeTab={activeTab}
                />
            </div>
        );
    }
    return <div>Loading ...</div>
}

export default LivePerformanceSubmissionPage;
